import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import Admin from "components/Admin/Admin";

import * as loginReducer from "containers/Login/reducer";
import * as accountsReducer from "containers/Accounts/reducer";

import * as adminReducer from "containers/Admin/reducer";
import * as foldersReducer from "containers/Folders/reducer";

/*
    This needs to not hook into account selection in the rest of the product.
    Switching workspaces in the admin panel SHOULD NOT cause the rest of the product to switch workspaces

    --Not sure if this switch is needed anymore: moving towards consolidating settings into admin panel
*/

class AdminContainer extends React.PureComponent {
  render() {
    const { selectedTenant } = this.props;
    return <Admin {...this.props} selectedTenant={selectedTenant} />;
  }
}

function updateShareState(tenantId, shareState, dispatch) {
  if (!tenantId) {
    return;
  }
  const shareMode = shareState ? "PUBLIC" : "PRIVATE";
  dispatch(adminReducer.updateSelectedTenantSharing(shareState));
  dispatch(loginReducer.handleChangeSharing(tenantId, shareMode));
}

function updateInfo(val, dispatch) {
  dispatch(adminReducer.updateSelectedOrganization(val));
  dispatch(adminReducer.fetchAccounts());
}

const mapDispatchToProps = (dispatch) => ({
  updateSelectedOrganization: (val) => updateInfo(val, dispatch),
  updateUsers: (tenantID) => dispatch(adminReducer.updateUsersCall(tenantID)),
  updateDeleteAWSAcc: (bool) => dispatch(adminReducer.updateDeleteAWSAcc(bool)),
  updateDeleteTarget: (target) => dispatch(adminReducer.updateDeleteTarget(target)),
  sendInviteFromTenant: (tenantID, email) => dispatch(adminReducer.sendInviteFromTenant(tenantID, email)),
  selectTenant: (tenant) => dispatch(loginReducer.selectTenant(tenant, true)),
  updateSelectedTenantSharing: (tenantId, shareState) => updateShareState(tenantId, shareState, dispatch),

  handleCreateAzureAccount: (name, config) => dispatch(accountsReducer.handleCreateAzureAccount(name, config)),
  handleCreateAWSAccount: (name, awsAccountID) => dispatch(accountsReducer.handleCreateAWSAccount(name, awsAccountID)),
  handleDelete: (accountId) => dispatch(accountsReducer.handleDelete(accountId)),

  updateAccountConfig: (id, config) => dispatch(adminReducer.updateAccountConfig(id, config))
});

const mapStateToProps = (state, ownProps) => ({
  users: adminReducer.getUsers(state),
  accounts: adminReducer.getAccounts(state),

  isLoadingAccounts: adminReducer.getIsLoadingAccounts(state),
  isLoadingUsers: adminReducer.getIsLoadingUsers(state),

  selectedOrganization: adminReducer.getSelectedOrganization(state),
  organizationID: loginReducer.getSelectedTenant(state),
  data: loginReducer.getTenants(state),
  activeTenant: loginReducer.getSelectedTenant(state),
  deleteAWSAcc: adminReducer.getDeleteAWSAcc(state),

  deleteTarget: adminReducer.getDeleteTarget(state),
  selectedTenantSharing: adminReducer.getSelectedTenantSharing(state),
  folders: foldersReducer.getFolders(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(AdminContainer);
